module.exports = __webpack_public_path__ + "img/ag.17a80615.svg";